/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
document.addEventListener("click", function (e) {
  const card = e.target.closest(".product-item");

  if (!card) return;

  const link = card.querySelector("a[href*='/products/']");
  if (!link) return;

  // If click is on overlay elements, redirect immediately
  if (
    e.target.classList.contains("product-item__image") ||
    e.target.closest(".product-item__image") ||
    e.target.closest(".product-item__media") ||
    e.target.closest(".swiper-container") ||
    e.target.tagName === "IMG"
  ) {
    window.location = link.href;
  }
});